import { fullInclusionTravelPeriodFilter } from 'lib/inclusionsTravelPeriodFilter'
import moment from 'moment/moment'
import { useMemo } from 'react'

export function useFullInclusionTravelPeriodFilter(
  inclusions: App.PackageInclusion[],
  checkIn?: moment.Moment,
  checkOut?: moment.Moment,
): App.PackageInclusion[] {
  return useMemo(() => {
    return fullInclusionTravelPeriodFilter(inclusions, checkIn, checkOut)
  }
  , [inclusions, checkIn, checkOut])
}
